<tt-page *ngIf="!!setting">
    <div *ngIf="'mobile' | mediaQuery">
        <tt-page-heading *ngIf="!!setting.webpage_heading" [ttModel]="setting.webpage_heading"></tt-page-heading>
        <tt-list-legacy class="col-xs-12 col-md-4 sp-0" [listItems]="itemsListConsignmentLines" ltype="multi" [optionfunc]="toggleChosen.bind(this)"></tt-list-legacy>

        <tt-card class="col-xs-12 col-md-4 sp-0">
            <tt-button-save ttText="consignmentlineselect_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-page-heading *ngIf="!!setting.webpage_heading" [ttModel]="setting.webpage_heading"></tt-page-heading>

        <tt-divider ttRememberId="consignmentlineselect_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="70">
                    <tt-list-legacy class="col-xs-12 col-md-12 p-5" [listItems]="itemsListConsignmentLines" ltype="multi" [optionfunc]="toggleChosen.bind(this)"></tt-list-legacy>

                    <tt-card class="col-xs-12 col-md-12 p-5">
                        <tt-button-save ttText="consignmentlineselect_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
